import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import LoginForm from "./components/LoginForm";
import TabSystem from "./components/TabSystem";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";

// Main App Component
function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [lowStockItems, setLowStockItems] = useState([]);
  const [cart, setCart] = useState([]);

  // Check for existing login on app start
  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");

    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
  }, []);
  
  useEffect(() => {
    if (token) {
      fetchLowStockItems();
    }
  }, [token]);

  // Fetch data functions
  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      // Avoid returning cached GET responses
      cache: "no-store",
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        // Best-effort cache prevention
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
    });

    if (response.status === 401) {
      // Clear token and user state
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setToken(null);
      setUser(null);

      // Redirect to login page
      window.location.href = "/";
      return null;
    }

    return response;
  };

  const fetchLowStockItems = async () => {
    if (!token) return;
    try {
      const response = await fetchWithAuth(
        `${BACKEND_URL}/api/inventory/low-stock`
      );
      if (response && response.ok) {
        const data = await response.json();
        setLowStockItems(data);
      }
    } catch (error) {
      console.error("Error fetching low stock items:", error);
    }
  };

  const handleLogin = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
  };

  const handleLogout = () => {
    // Clear token and user state
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);

    // Redirect to login page
    window.location.href = "/";
  };

  if (!user || !token) {
    return <LoginForm onLogin={handleLogin} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF7D1] to-[#FCE38A]">
      <Header user={user} cart={cart} lowStockItems={lowStockItems} onLogout={handleLogout} />
      <TabSystem />
    </div>
  );
}

export default App;
